var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-recaptcha',_vm._g(_vm._b({ref:'recaptcha',attrs:{"sitekey":_vm.siteKey,"size":"invisible"},on:{"expired":_vm.onExpired}},'vue-recaptcha',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }